import { useEffect, useState } from 'react';

import { getFormData } from '@/_utils';

function TextArea({ currentObj, pageCallBack }) {
  const [formValue, setFormValue] = useState('');

  useEffect(() => {
    let formData = getFormData();
    if (formData) {
      for (const [key, value] of Object.entries(formData)) {
        if (key === currentObj.api) {
          if (value) {
            setFormValue(value);
          }
        }
      }
    }
  }, [currentObj.api]);

  const handleOnChange = (e) => {
    const val = e.target.value;
    const formData = getFormData() ?? {};

    let keyExist = false;
    if (formData.length > 0) {
      for (const [key, value] of Object.entries(formData)) {
        if (key === currentObj.api) {
          formData[key] = value;
          keyExist = true;
        }
      }
    } else if (!keyExist) {
      formData[currentObj.api] = val;
    }

    if (val.length > 0) {
      localStorage.setItem('formData', JSON.stringify(formData));
      setFormValue(val);
      pageCallBack(currentObj.api, val);
    } else {
      setFormValue(val);
    }
  };
  const handleNumberOfRows = () => {
    const width = window.innerWidth;
    let val = 6;
    if (width >= 1280 && width < 1920) {
      val = 9;
    } else if (width >= 1920) {
      val = 5;
    }
    return val;
  };
  const numberOfRows = handleNumberOfRows();

  return (
    <div className="rounded-lg rounded-tl-none bg-white p-4 shadow-input-primary-light">
      <textarea
        className="h-auto w-full resize-none rounded-none border-none p-0 leading-5 text-primary-medium-dark placeholder-primary-medium shadow-none outline-none focus:border-none focus:outline-none focus:ring-0"
        placeholder="Enter your answer here..."
        onChange={(e) => handleOnChange(e)}
        value={formValue}
        rows={numberOfRows}
      />
    </div>
  );
}

export default TextArea;
